import { useEffect } from 'react';

/**
 * Set the document favicon. Accepts a data URL, absolute URL, or path.
 * Restores the previous favicon on cleanup.
 */
export default function useFavicon(href) {
  useEffect(() => {
    if (!href) return;
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    const previous = link.href;
    link.href = href;
    return () => { link.href = previous; };
  }, [href]);
}
